export function getPreOrderInfo (params) {
  return this.fetch({
    method: 'get',
    url: 'mall-server/api/tv/preorder/v4/getPreOrderInfo',
    params
  })
}
export function getOrderList (data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/order/v3/getOrderList',
    data
  })
}
// 取消订单
export function cancelOrder (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/order/v3/cancelOrder',
    params
  })
}
// 确认收货
export function confirmReceived (params) {
  return this.fetch({
    method: 'get',
    url: 'mall-server/api/order/v3/confirmReceived',
    params
  })
}
// 立即购买下单
export function getBuyNew (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/order/v3/getBuy',
    params
  })
}
// 兑换下单详情接口
export function getExchangeBuy (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/order/v3/getExchangeBuy',
    params
  })
}
//  秒杀下单详情接口
export function skBuyNew (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/order/v3/skBuy',
    params
  })
}

// 活动叠加计算最后金额接口
export function getCalculateSuperimposeAct (data) {
  return this.fetch({
    method: 'POST',
    platformCode: true,
    url: 'mall-server/api/order/v3/calculateSuperimposeAct',
    data
  })
}

// 秒杀抢购生成订单
export function saveOrderSkBuy (data) {
  return this.fetch({
    method: 'POST',
    platformCode: true,
    url: 'mall-server/api/order/v3/saveOrderSkBuy',
    data
  })
}

// 商品详情页购买生成订单
export function saveOrderGetBuyNew (data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/order/v3/saveOrderGetBuy',
    data
  })
}

// 购物车购买生成订单
export function saveOrderCartNew (data) {
  return this.fetch({
    method: 'POST',
    platformCode: true,
    url: 'mall-server/api/order/v3/saveOrderCart',
    data
  })
}

export function saveOrderExchangeBuy(data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/order/v3/saveOrderExchange',
    data,
    platformCode: true
  })
}

// 订单详情
export function getOrderInfo (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/order/v3/getOrderInfo',
    params
  })
}
// 获取各种类型的订单数量
export function getOrderNumber (params) {
  return this.fetch({
    method: 'GET',
    platformCode: true,
    url: 'mall-server/api/order/v3/getOrderNumber',
    params
  })
}
// 领取优惠券
export function sendBonusType (data) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/act/coupon/receive',
    params: data
  })
}

// =====退款相关=========
// 保存售后单信息
export function saveBackRefund (data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/refund/v1/saveBackRefund ',
    data
  })
}

// 根据售后单号查看售后进度
export function viewBackRefundByRefundCode (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/refund/v1/viewBackRefundByRefundCode',
    params
  })
}

// 根据订单商品Id查看售后进度
export function viewBackRefundByOrderGoodsId (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/refund/v1/viewBackRefundByOrderGoodsId',
    params
  })
}

// 获取物流信息
export function getKdData (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/kd/v1/query',
    params
  })
}
// 生成二维码
// export function action (data) {
//   return this.fetch({
//     method: 'POST',
//     url: 'mini-program-server/api/util/image/action',
//     data
//   })
// }
//  退出登陆
export function loginOut (data) {
  return this.fetch({
    method: 'POST',
    url: 'mall/sign/out',
    data
  })
}
// 保存退货单快递信息
export function saveBackRefundExpress (data) {
  return this.fetch({
    method: 'POST',
    platformCode: true,
    url: 'mall-server/api/refund/v1/saveBackRefundExpress',
    data
  })
}

// 获取售后协商历史
export function getBackRefundManualHistory (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/refund/v1/getManualHistory',
    params
  })
}

// // 下载卡密excel
// export function downloadVirtualCardExcel (params) {
//   return this.fetch({
//     method: 'GET',
//     url: 'mini-program-server/api/order/v1/downloadVirtualCardExcel',
//     params
//   })
// }
// // 下载卡密之前获取授权
// export function cardCreateUserToken (params) {
//   return this.fetch({
//     method: 'GET',
//     url: 'mini-program-server/api/order/v1/downloadVirtualCardCreateUserToken',
//     params
//   })
// }
// 发送卡密
// export function sendEmailVirtualCardExcel (data) {
//   return this.fetch({
//     method: 'POST',
//     url: 'mini-program-server/api/order/v1/sendEmailVirtualCardExcel',
//     data
//   })
// }
// 根据订单号获取fxOrder
// export function getFxOrderByOrderSn (params) {
//   return this.fetch({
//     method: 'GET',
//     url: 'wx-server/payroll/v1/order/getFxOrderByOrderSn',
//     params
//   })
// }
